// import { debug } from './pages/debug';

// Common
import { inview } from './pages/inview';

// Pages
import { home } from './pages/home';
import { ajistudio } from './pages/ajistudio';
// import { storage } from './pages/storage';
import { news } from './pages/news';
import { newsDetails } from './pages/news-details';


jQuery(function($){
    const bp = 767;
    // Common
    inview(bp, $);

    $(window).on('load',function(){
        $('body').removeClass('preload');
    });

    // Pages
    if ($('body.home').length) {
        home(bp, $);
    } else if($('body.ajistudio').length) {
        ajistudio(bp, $);
    } else if($('body.storage').length) {
        // storage(bp, $);
    } else if($('body.news').length) {
        news(bp, $);
    } else if($('body.news-details').length) {
        newsDetails(bp, $);
    }

    const overrideBreadcrumbsTtl = () => {
        const limitStrLen = 17;
        const breadcrumbTtl = $('.post.post-post.current-item');
        const breadcrumbTtlText = breadcrumbTtl.text();
        const breadcrumbTtlLen = breadcrumbTtl.text().length;

        if(breadcrumbTtlLen > limitStrLen ) {
            breadcrumbTtl.html('<br class="is-sp">'+ breadcrumbTtlText);
        }
    };
    overrideBreadcrumbsTtl();


});
